import React from "react";
import Modal from "../../../../Common/Modal";
import MtiButton from "../../../../Buttons/MtiButton";
import "./RunAutoCalibrationModal.css";
import WarningSign from "../../../../../assets/icons/warning-sign.svg"

type Props = {
  show: boolean;
  onClickIgnore: () => void;
  onClickOk: () => void;
};

export default function PlateDetectedModal({
  show,
  onClickIgnore,
  onClickOk,
}: Props) {
  return (
    <Modal
      show={show}
      hideOnBackdropClick={false}
      className="auto-calibration-run-modal"
    >
      <Modal.Header
        title={"Calibration Process"}
        hideButtonEnabled={false}
        className="auto-calibration-run-header"
      />
      <Modal.Body className="auto-calibration-run-body">
        <img src={WarningSign} alt="warning-sign" />
        <div className="progress-title">
          <p>Plate detected on your Psr Arm</p>
        </div>
        <div className="progress-subtittle">Please remove your plate before continuing this process</div>
      </Modal.Body>
      <Modal.Footer className="auto-calibration-run-footer">
        <MtiButton
          variant="secondary"
          colorVariant="default"
          size="large"
          onClick={onClickIgnore}
          style={{
            width: 157,
          }}
        >
          <span>IGNORE</span>
        </MtiButton>
        <MtiButton
          variant="primary"
          colorVariant="default"
          size="large"
          onClick={onClickOk}
          style={{
            width: 157,
          }}
        >
          <span>OK</span>
        </MtiButton>
      </Modal.Footer>
    </Modal>
  );
}
